
import React, {useEffect, useState} from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import toastr from 'toastr';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';
import { loftyHandleCountShoppingCart } from '../../util/handleCount';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';

import {createchambeadoresinteresados0cs8a } from '../../api/chambeadoresinteresados0cs8a.api'

import './contactofwrl5h.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    



const lofty_value_default_comotedescribesm5djfi_690fe91de307249250073d99 = (param) => {
	if (param === 'estudiante') {
		return 'Estudiante';
	}
	if (param === 'noestudiante') {
		return 'No estudiante';
	}
	return param;
}

const lofty_value_default_departamentooj2gk_690fe91de307249250073d99 = (param) => {
	if (param === 'atlantida') {
		return 'Atlántida';
	}
	if (param === 'choluteca') {
		return 'Choluteca';
	}
	if (param === 'colon') {
		return 'Colón';
	}
	if (param === 'comayagua') {
		return 'Comayagua';
	}
	if (param === 'copan') {
		return 'Copán';
	}
	if (param === 'cortes') {
		return 'Cortés';
	}
	if (param === 'elparaiso') {
		return 'El Paraíso';
	}
	if (param === 'franciscomorazan') {
		return 'Francisco Morazán';
	}
	if (param === 'graciasadios') {
		return 'Gracias a Dios';
	}
	if (param === 'intibuca') {
		return 'Intibucá';
	}
	if (param === 'isladelabahia') {
		return 'Islas de la Bahía';
	}
	if (param === 'lapaz') {
		return 'La Paz';
	}
	if (param === 'lempira') {
		return 'Lempira';
	}
	if (param === 'ocotepeque') {
		return 'Ocotepeque';
	}
	if (param === 'olancho') {
		return 'Olancho';
	}
	if (param === 'santabarbara') {
		return 'Santa Bárbara';
	}
	if (param === 'valle') {
		return 'Valle';
	}
	if (param === 'yoro') {
		return 'Yoro';
	}
	return param;
}

const lofty_value_default_qutegustariaparticipartog47k_690fe91de307249250073d99 = (param) => {
	if (param === 'comunidad') {
		return 'Participa en mi comunidad local';
	}
	if (param === 'oprtunidades') {
		return 'Conozca las oportunidades profesionales';
	}
	if (param === 'actualizaciones') {
		return 'Envíame actualizaciones periódicas';
	}
	if (param === 'conferencia') {
		return 'Asistir a una conferencia';
	}
	return param;
}




const Pcontactofwrl5h = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {



useEffect(() => {
		const loftyHandleData = async () => {
		}
		loftyHandleData();
	}, []);



  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id690fecc18e5aed52dc850ace" >

      <div id="ii5j" className="">
      
      <div id="i2wm" className="">
      
      <div id="i3to" className="">
      
      <div id="i4zac" className="">
      
      <div id="ifggiv" className="">
      
      <div id="iq3oci" className="">
      
        <a
          target="_blank"
          className="redes-sociales "
          id="iyoins"
          href="https://www.facebook.com/share/1MZa4kJbWJ/"
        >
          
      <img
        className=""
        id="iqxn7c"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx0u9w.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target="_blank"
          className="redes-sociales "
          id="iup45h"
          href="https://x.com/chambahonduras?t=paP02Yu8E246utuee6OmXA&s=09"
        >
          
      <img
        className=""
        id="iyzeef"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx2duv.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target="_blank"
          className="redes-sociales "
          id="if3occ"
          href="https://www.instagram.com/chamba.hn?igsh=MWdzNTRtZDRqOXN3MQ=="
        >
          
      <img
        className=""
        id="i3pbhl"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx2wo7.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target="_blank"
          className="redes-sociales "
          id="irgcil"
          href="https://www.youtube.com/@ChambaHonduras"
        >
          
      <img
        className=""
        id="iro1nx"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx35nw.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        <>
        </>
      </div>
      
      <div id="i7fo6y" className="">
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="istkj" className="">
      
      <div id="ivpj2" className="">
      
        <LoftyDropdownComponent
          id="ir2m0g"
          className="gjs-dropdown-menu-container "
          childrenShow={
            <>
              <div id="itat18" className="gjs-dropdown-menu-trigger link-navegacion ">
<>Ecosistema chamba
        </></div>

            </>
          }
          childrenHover={
            <>
              <div id="i3k08a" className="gjs-dropdown-menu-content " style={{display: 'block'}}>

        <a
          target=""
          className="link-navegacion "
          id="i0llh"
          href="/index"
        >
          
    <div id="ij1vq" className="">
    <>Chamba Index</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-navegacion "
          id="ig7xki"
          href="/chambanomics"
        >
          
    <div id="if6wrb" className="">
    <>Chambanomics</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-navegacion "
          id="i68lj"
          href="/chambometro"
        >
          
    <div id="inisp" className="">
    <>Chambómetro Electoral</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-navegacion "
          id="iog9i6"
          href="/talks"
        >
          
    <div id="iogkoj" className="">
    <>Chamba talks</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-navegacion "
          id="ievl0d"
          href="/chambeador"
        >
          
    <div id="i40bdb" className="">
    <>Chambeador del año</>
    </div>
    
        </a>
        </div>

            </>
          }
        />
        
        <a
          target=""
          className="link-navegacion "
          id="ilnkvn"
          href="/fundacion"
        >
          
    <div id="iv451u" className="">
    <>Fundación</>
    </div>
    
        </a>
        <>
        </>
      </div>
      
      <div id="iaa1w" className="">
      
        <a
          target=""
          className=""
          id="itud73"
          href="/"
        >
          
      <img
        className=""
        id="ilkbh"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx82cj.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        <>
        </>
      </div>
      
      <div id="i4z2t" className="">
      
        <a
          target=""
          className="link-navegacion "
          id="ixf4dl"
          href="/sobrenosotros"
        >
          
    <div id="ijolgi" className="">
    <>Sobre Nosotros</>
    </div>
    
        </a>
        
        <a
          target="_blank"
          className="link-navegacion "
          id="ip99yp"
          href="https://cne.chamba.hn/"
        >
          
    <div id="i8d1jv" className="">
    <>Centro electoral</>
    </div>
    
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i23lgf" className="">
      
      <img
        className=""
        id="iaxk7b"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx82cj.png"
        alt="undefined"
      />
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>Inicio</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/sobrenosotros"
        type=""
      >
        <>Sobre Nosotros</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/chambanomics"
        type=""
      >
        <>Chamba Index</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/index"
        type=""
      >
        <>Chamba Index</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/talks"
        type=""
      >
        <>Chamba Talks</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/fundacion"
        type=""
      >
        <>Fundación</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/chambometro"
        type=""
      >
        <>Chambómetro</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/chambeador"
        type=""
      >
        <>Chambeador del año</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/agregarcv"
        type=""
      >
        <>Postular</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      </ul>
      
      </div>
      
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <video
        id="iggdui"
        className=""
        src="https://assetsprojects.s3.amazonaws.com/404pziimhr1nqq0.mp4"
        loop={true}
        autoPlay={true}
        controls={undefined}
        muted={true}
        playsInline={true}
      />
      <>
        </>
      </div>
      
      <div id="i8g6" className="">
      
      <img
        className=""
        id="izriq"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnxjnni.png"
        alt="undefined"
      />
      
      <div
        id="i9enf4"
        className=""
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div id="i7inz" className="">
      
      <div className="" id="izquz">
        <>¿Qué es El Chambeador del Año?</>
      <br className="" id="" />
      
      </div>
      
      <div className="" id="ic7klk">
        <>Es un programa que premia a individuos, empresas y organizaciones que inspiran con su ejemplo y contribuyen al desarrollo económico, social y tecnológico de Honduras.</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      
      <div
        id="ic1m1l"
        className=""
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
        <div className="" id="iyrhli">
          
      <form
        id="in22gt"
        className=""
        onSubmit={async (e) => {
				e.preventDefault();
				try {
						const lofty_response = await createchambeadoresinteresados0cs8a({
						token: 'aasdas',
						nombrejev91: e.target.nombrejev91?.value,
						apellidotb7f6: e.target.apellidotb7f6?.value,
						telfono7rhptj: e.target.telfono7rhptj?.value,
						correo3v14e: e.target.correo3v14e?.value,
						comotedescribesm5djfi: e.target.comotedescribesm5djfi?.value,
						departamentooj2gk: e.target.departamentooj2gk?.value,
						qutegustariaparticipartog47k: e.target.qutegustariaparticipartog47k?.value,
					});
					window.location.href = `/exitoso`;
		} catch (error) {
					console.log(error);
					if (error.info) {
						alert(error.info);
					}
				}
			}}
		
      >
        
      <div id="is2g15" className="">
      
      <label id="" className="">
      <>Nombre</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="nombrejev91"
        type="text"
        placeholder="Perez"
        className="input "
        id="i6waco"
      />
      
      </div>
      
      <div id="iduvo2" className="">
      
      <label id="" className="">
      <>Apellido</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="apellidotb7f6"
        type="text"
        placeholder="Cruz"
        className="input "
        id="ifu9ss"
      />
      
      </div>
      
      <div id="iarczv" className="">
      
      <label id="" className="">
      <>Teléfono</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="telfono7rhptj"
        type="text"
        placeholder="98999098"
        className="input "
        id="ifqx0r"
      />
      
      </div>
      
      <div id="ib2kgr" className="">
      
      <label id="" className="">
      <>Correo</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="correo3v14e"
        type="text"
        placeholder="persona@correo.com"
        className="input "
        id="i2upgx"
      />
      
      </div>
      
      <div id="iewayt" className="">
      
      <label id="" className="">
      <>Como te describes</>
      </label>
      
      <br className="" id="" />
      
        <select
          name="comotedescribesm5djfi"
          className="input "
          id="ia09oc"
        >
          <option value={`estudiante`}>Estudiante</option>
<option value={`noestudiante`}>No estudiante</option>

        </select>
        
      </div>
      
      <div id="ictwmc" className="">
      
      <label id="" className="">
      <>Departamento</>
      </label>
      
      <br className="" id="" />
      
        <select
          name="departamentooj2gk"
          className="input "
          id="i6xl0j"
        >
          <option value={`atlantida`}>Atlántida</option>
<option value={`choluteca`}>Choluteca</option>
<option value={`colon`}>Colón</option>
<option value={`comayagua`}>Comayagua</option>
<option value={`copan`}>Copán</option>
<option value={`cortes`}>Cortés</option>
<option value={`elparaiso`}>El Paraíso</option>
<option value={`franciscomorazan`}>Francisco Morazán</option>
<option value={`graciasadios`}>Gracias a Dios</option>
<option value={`intibuca`}>Intibucá</option>
<option value={`isladelabahia`}>Islas de la Bahía</option>
<option value={`lapaz`}>La Paz</option>
<option value={`lempira`}>Lempira</option>
<option value={`ocotepeque`}>Ocotepeque</option>
<option value={`olancho`}>Olancho</option>
<option value={`santabarbara`}>Santa Bárbara</option>
<option value={`valle`}>Valle</option>
<option value={`yoro`}>Yoro</option>

        </select>
        
      </div>
      
      <div id="ifrat3" className="">
      
      <label id="" className="">
      <>Qué te gustaria participar</>
      </label>
      
      <br className="" id="" />
      
        <select
          name="qutegustariaparticipartog47k"
          className="input "
          id="it5zgi"
        >
          <option value={`comunidad`}>Participa en mi comunidad local</option>
<option value={`oprtunidades`}>Conozca las oportunidades profesionales</option>
<option value={`actualizaciones`}>Envíame actualizaciones periódicas</option>
<option value={`conferencia`}>Asistir a una conferencia</option>

        </select>
        
      </div>
      
      <div id="ilvkbf" className="">
      
      <button
        type="submit"
        name=""
        id="i7ngjg"
        className=""
        
      >
      
      <div id="i12e1p" className="">
      <>Enviar</>
      </div>
      
      </button>
      <>
        </>
      </div>
      
      </form>
      
        </div>
        
      </div>
      
      </div>
      
      <img
        className=""
        id="i68z7"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnxlys4.png"
        alt="undefined"
      />
      
      <div
        id="ide922"
        className=""
        data-aos="fade-down"
        data-aos-duration="2000"
      >
      
      <div className="" id="ijluj">
        <>Nuestra comunidad está formada por jóvenes, emprendedores, empresas, universidades y soñadores que comparten una misma visión: construir un país con más oportunidades, innovación y desarrollo.</>
      <br className="" id="" />
      
      </div>
      
      </div>
      <>
        </>
      </div>
      
      <div id="im78" className="">
      
      <div id="imr134" className="">
      
      <div id="i3kmzi" className="">
      
      <img
        className=""
        id="ijd9oi"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx82cj.png"
        alt="undefined"
      />
      
      <div className="" id="iq6yph">
        <>En CHAMBA creemos que el verdadero cambio comienza cuando las personas tienen oportunidades reales. No hablamos de discursos, hablamos de empleo, educación responsabilidad fiscal, libre mercado y gobierno limitado. Nuestro propósito es conectar a los hondureños que quieren salir adelante con las herramientas, la información y las redes que pueden hacerlo posible.</>
      </div>
      <>
        </>
      </div>
      
      <div id="igpnrp" className="">
      
      <div className="" id="iwmzhr">
        <>Siguenos</>
      </div>
      
      <div id="ii0mf" className="">
      
        <a
          target="_blank"
          className="redes-sociales "
          id="igd3x"
          href="https://www.facebook.com/share/1MZa4kJbWJ/"
        >
          
      <img
        className=""
        id="ivqnc"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx0u9w.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target="_blank"
          className="redes-sociales "
          id="i5j0k"
          href="https://x.com/chambahonduras?t=paP02Yu8E246utuee6OmXA&s=09"
        >
          
      <img
        className=""
        id="ibnrn"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx2duv.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target="_blank"
          className="redes-sociales "
          id="ir76u"
          href="https://www.instagram.com/chamba.hn?igsh=MWdzNTRtZDRqOXN3MQ=="
        >
          
      <img
        className=""
        id="imcck"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx2wo7.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target="_blank"
          className="redes-sociales "
          id="izuti"
          href="https://www.youtube.com/@ChambaHonduras"
        >
          
      <img
        className=""
        id="iyz7f"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhnx35nw.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div className="" id="id4zm3">
        <>© 2025 CHAMBA. Todos los derechos reservados.</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pcontactofwrl5h);
  